import { useEffect, useRef, useState } from 'react';
import '../assets/styles/Drive.css';

/**
 * Un nom qu'on peut renommer sur place : cliquer « Renommer » (ou le
 * bouton fourni par le parent) ouvre un champ à la place du texte ; Entrée
 * ou ✓ enregistre, Échap ou × annule. Le parent fait l'appel serveur dans
 * `onRenommer(nouveauNom)` et renvoie sa promesse.
 */
function NomEditable({ valeur, edition, onRenommer, onFermer, className = '' }) {
  const [saisie, setSaisie] = useState(valeur);
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);
  const champ = useRef(null);

  useEffect(() => {
    if (edition) {
      setSaisie(valeur);
      setErreur(null);
      // Le champ prend la main tout de suite, texte sélectionné.
      setTimeout(() => {
        champ.current?.focus();
        champ.current?.select();
      }, 0);
    }
  }, [edition, valeur]);

  async function valider() {
    const nom = saisie.trim();
    if (!nom) {
      setErreur('Le nom ne peut pas être vide.');
      return;
    }
    if (nom === valeur) {
      onFermer();
      return;
    }
    setEnCours(true);
    setErreur(null);
    try {
      await onRenommer(nom);
      onFermer();
    } catch (err) {
      setErreur(err.message || 'Renommage impossible.');
    } finally {
      setEnCours(false);
    }
  }

  if (!edition) return <span className={className}>{valeur}</span>;

  return (
    <span className="nom-editable" onClick={(e) => e.stopPropagation()}>
      <input
        ref={champ}
        type="text"
        className="nom-editable-champ"
        value={saisie}
        disabled={enCours}
        maxLength={200}
        aria-label="Nouveau nom"
        onChange={(e) => setSaisie(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            valider();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            onFermer();
          }
        }}
      />
      <button
        type="button"
        className="nom-editable-bouton nom-editable-ok"
        onClick={valider}
        disabled={enCours}
        title="Enregistrer (Entrée)"
        aria-label="Enregistrer"
      >
        ✓
      </button>
      <button
        type="button"
        className="nom-editable-bouton"
        onClick={onFermer}
        disabled={enCours}
        title="Annuler (Échap)"
        aria-label="Annuler"
      >
        ×
      </button>
      {erreur && <span className="nom-editable-erreur">{erreur}</span>}
    </span>
  );
}

export default NomEditable;
